import { useState, useEffect } from 'react';

/**
 * Returns the current window inner width, updating on resize.
 * Use to apply responsive overrides to inline-style layouts.
 *
 * Common breakpoints:
 *   mobile  : width < 640
 *   tablet  : width < 1024
 *   desktop : width >= 1024
 */
const useWindowWidth = () => {
  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );

  useEffect(() => {
    let rafId;
    const handleResize = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => setWidth(window.innerWidth));
    };
    window.addEventListener('resize', handleResize);
    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return width;
};

export default useWindowWidth;
